import About from "@/components/sections/About";
import Transparency from "@/components/sections/Transparency";
import Faq from "@/components/sections/Faq";
import Contact from "@/components/sections/Contact";

export default function AboutPage() {
  return (
    <div>
      <About />
      <Transparency />
      <Faq />
      <Contact />
    </div>
  );
}
